module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container\"> <div class=\"row my-7\"> <div class=\"col-sm-6 col-md-4 mx-auto\"> <h3>Password Reset</h3> <form id=\"password_reset_form\"> <div class=\"form-group\"> <input class=\"form-control\" id=\"password_reset_password\" name=\"password_reset[password]\" placeholder=\"Password\" type=\"password\"> </div> <div class=\"form-group\"> <input class=\"form-control\" id=\"password_reset_password_confirmation\" name=\"password_reset[password_confirmation]\" placeholder=\"Password Confirmation\" type=\"password\"> </div> <button class=\"btn btn-lg btn-secondary pull-right\" type=\"submit\">Submit</button> </form> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/password_reset_page/template.ejs
// module id = 1151
// module chunks = 1